import { windowWidth } from "@styles/global";
import styled from "styled-components";

const LoginFormContainer = styled.div`
  background-color: white;
  padding: 20px 50px;
  width: 100%;
  height: 90%;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-evenly;
  overflow: hidden;
  max-height: 600px;

  @media (max-width: ${windowWidth.mobile.large}) {
    padding: 20 20px !important;
  }

  > form {
    width: 100% !important;
    display: flex;
    flex-direction: column;
    align-items: center;

    > * {
      width: 100%;
    }

    > button {
      margin-top: 20px;
      width: 50%;
      background-color: ${(props) => props.theme.colors.primary};

      :hover {
        background-color: ${(props) => props.theme.colors.secondary};
      }
    }
  }

`;

const LoginFormLogo = styled.div`
  width: 50%;

  @media (max-height: ${windowWidth.tablet}) and (min-width: ${windowWidth.tablet}) {
    width: 45% !important;
  }

  @media (max-height: 700px) {
    padding-bottom: 20px;
  }
`;

const ForgotPasswordContainer = styled.div`
  button {
    color: ${(props) => props.theme.colors.primary};
  }
`;

export { LoginFormContainer, LoginFormLogo, ForgotPasswordContainer };
